import { Injectable } from "@angular/core"
import { Http } from "@angular/http"
import { Observable } from 'rxjs/Observable';
import { HttpHelperService } from './helpers/http-helper.service';
import { BehaviorSubject } from "rxjs";
import { UserService } from "./user.service";

@Injectable()

export class IndustryService {

    private industriesSource: BehaviorSubject<any> = new BehaviorSubject([])
    private careersSource: BehaviorSubject<any> = new BehaviorSubject(null)
    private careerSource: BehaviorSubject<any> = new BehaviorSubject(null)
    private courseCount: BehaviorSubject<any> = new BehaviorSubject(null)
    private courseSource: BehaviorSubject<any> = new BehaviorSubject(null)
    private providersSource: BehaviorSubject<any> = new BehaviorSubject(null)
    private providerSource: BehaviorSubject<any> = new BehaviorSubject(null)
    private providerRating: BehaviorSubject<any> = new BehaviorSubject(null)

    constructor(
        private http: Http,
        private httpHelperService: HttpHelperService
    ) { }

    get Industries() {
        return this.industriesSource.asObservable()
    }

    get Careers() {
        return this.careersSource.asObservable()
    }

    get Career() {
        return this.careerSource.asObservable()
    }

    get CourseCount() {
        return this.courseCount.asObservable()
    }

    get Course() {
        return this.courseSource.asObservable()
    }

    get Providers() {
        return this.providersSource.asObservable()
    }

    get Provider() {
        return this.providerSource.asObservable()
    }
    get ProviderRating() {
        return this.providerRating.asObservable()
    }

    getIndustries() {
        this.http.get('/api/industries', { headers: this.httpHelperService.headers(false) })
            .subscribe((res: any) => {
                let result = res.json()
                this.industriesSource.next(result)
            },
            error => {
                console.log(error)
            })
    }

    getCareersByIndustryId(industryId): Observable<any> {
        const body = { industryId: industryId }
        return this.http.post('/api/getcareersbyindustryid', body, { headers: this.httpHelperService.headers(false) })
    }

    getCareerBySlug(careerSlug): Observable<any> {
        const body = { careerSlug: careerSlug }
        return this.http.post('/api/getcareerbyslug', body, { headers: this.httpHelperService.headers(false) })
    }

    getCourseCount() {
        const body = {}
        this.http.post('/api/getcoursecount', body, { headers: this.httpHelperService.headers(false) })
            .subscribe((res: any) => {
                let result = res.json()
                if (result) {
                    this.courseCount.next(result)
                }
            },
            err => {
                console.log(err)
            })
    }

    getCoursesByCareerId(careerId): Observable<any> {
        const body = { careerId: careerId }
        return this.http.post('/api/getcoursesbycareerid', body, { headers: this.httpHelperService.headers(false) })
    }

    getCourseBySlug(courseSlug): Observable<any> {
        const body = { courseSlug: courseSlug }
        return this.http.post('/api/getcoursebyslug', body, { headers: this.httpHelperService.headers(false) })
    }

    getProvidersByCourseId(courseId): Observable<any> {
        const body = { courseId: courseId }
        return this.http.post('/api/getprovidersbycourseid', body, { headers: this.httpHelperService.headers(false) })
    }

    getProviderBySlug(providerSlug): Observable<any> {
        const body = { providerSlug: providerSlug }
        return this.http.post('/api/getproviderbyslug', body, { headers: this.httpHelperService.headers(false) })
    }

    getOverallProviderRating(providerId): Observable<any> {
        const body = { providerId: providerId }
        return this.http.post('/api/getoverallproviderrating', body, { headers: this.httpHelperService.headers(false) })
    }

    handleErrors(error: Response) {
        return Observable.throw(error);
    }

    getTitleString(titleStr) {
        let str = titleStr.split('-')
        let title = ''
        for (let i = 0; i < str.length; i++) {
            if (i === str.length - 1) {
                title += this.capitalizeFirstLetter(str[i])
            } else {
                title += this.capitalizeFirstLetter(str[i]) + ' '
            }
        }
        return title
    }

    capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1)
    }

    getIndustryIdForCourse(careerId): Observable<any> {
        const body = {
            careerId: careerId
        }
        return this.http.post('/api/getindustryidforcourse', body, { headers: this.httpHelperService.headers(false) })
    }

    getCareers(): Observable<any> {
        return this.http.get('/api/careers', { headers: this.httpHelperService.headers(false) })
    }

    updateIndustryContent(id, description): Observable<any> {
        const body = {
            id: id,
            description: description
        }
        return this.http.post('/api/updateindustry', body, { headers: this.httpHelperService.headers(true, UserService.token) })
    }

    updateCareerContent(id, description): Observable<any> {
        const body = {
            id: id,
            description: description
        }
		return this.http.post('/api/updatecareer', body, { headers: this.httpHelperService.headers(true, UserService.token) })
    }

    getCourses(): Observable<any> {
        return this.http.get('/api/courses', { headers: this.httpHelperService.headers(false) })
    }

    updateCourseContent(id, description): Observable<any> {
        const body = {
            id: id,
            description: description
        }
		return this.http.post('/api/updatecourse', body, { headers: this.httpHelperService.headers(true, UserService.token) })
    }

    getIndustriesList(): Observable<any> {
        return this.http.get('/api/industrieslist', { headers: this.httpHelperService.headers(false) })
    }

    getRandomProvider(): Observable<any> {
        return this.http.get('/api/getrandomprovider', { headers: this.httpHelperService.headers(false) })
    }
}



// WEBPACK FOOTER //
// ./src/app/services/industry.service.ts